export default __webpack_public_path__ + "static/media/active_icon.b0f6bc53.svg";